import { createSlice } from "@reduxjs/toolkit";

const salesDashBoardSlice = createSlice({
  name: "salesDashboard",
  initialState: {
    overviewData: [],
    salesOrders: [],
    monthlyChartData: [],
    yearlyChartData: [],
    weeklyChartData: [],
  },
  reducers: {
    setOverViewData: (state, action) => {
      state.overviewData = action.payload;
    },

    setSalesOrders: (state, action) => {
      state.salesOrders = action.payload;
    },
    setMonthlyChartData: (state, action) => {
      state.monthlyChartData = action.payload;
    },
    setYearlyChartData: (state, action) => {
      state.yearlyChartData = action.payload;
    },
    setWeeklyChartData: (state, action) => {
      state.weeklyChartData = action.payload;
    },
  },
});

export const { setOverViewData, setSalesOrders, setMonthlyChartData,setYearlyChartData,setWeeklyChartData } =
  salesDashBoardSlice.actions;

export default salesDashBoardSlice.reducer;
